import css from './animated.module.scss';
import classNames from 'classnames';

export default function Cloud({cnReplace}) {
  return (
    <img loading={'lazy'} src={'/clouds.svg'}
         alt={'img2'}
         className={classNames(css.img, cnReplace)}/>
  );
}